// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/stall-recognition.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/stall-recognition/stall-recognition.js';

mount([g0]);
